<paginated-track-list [loadFn]="loadMoreFn" [initialData]="channel.content" [hideNoResultsMessage]="true" [disablePagination]="nested || channel.config.disablePagination"></paginated-track-list>
